function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgContactStatus = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.789,
    height: 14.709,
    viewBox: "0 0 14.789 14.709",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1193"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20857",
    d: "M18143.295 9952.684a.749.749 0 0 1-.8-.793v-3.349a3.032 3.032 0 0 1 1.754-2.789 4.174 4.174 0 0 1-.158-1.034 3.188 3.188 0 0 1 6.375 0 4.752 4.752 0 0 1-.16 1.034 3.025 3.025 0 0 1 1.75 2.789v3.349a.746.746 0 0 1-.793.793zm.8-4.142v2.552h6.375v-2.552a1.436 1.436 0 0 0-1.117-1.354 3.09 3.09 0 0 1-4.143 0 1.313 1.313 0 0 0-1.116 1.354zm1.594-3.823a1.593 1.593 0 1 0 1.592-1.591 1.6 1.6 0 0 0-1.593 1.591zm6.75-1.887h-.01l-1.883-1.882a.886.886 0 0 1 1.254-1.253l1.254 1.253 2.719-2.721a.888.888 0 0 1 1.254 1.258l-3.34 3.341a.875.875 0 0 1-.629.26.863.863 0 0 1-.62-.256z",
    transform: "translate(-18142.498 -9937.975)",
    style: {
      fill: "#c4c4c4"
    }
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgContactStatus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/contactStatus.c653a3c2.svg";
export { ForwardRef as ReactComponent };